Array.from(document.querySelectorAll('.textHide')).forEach(el => {
  const imageText = el.textContent

  el.addEventListener('copy', (e) => {
    e.preventDefault()
    e.clipboardData.setData('text/plain', imageText)
  })
})
